<template>
  <div class="kanban-board">
    <v-row class="kanban-columns" align="stretch" no-gutters>
      <v-col v-for="column in kanbanColumns" :key="column.status" cols="12" md="4" class="kanban-column-wrapper">
        <KanbanColumn :title="column.title" :status="column.status" :color="column.color"
          :activities="getActivitiesByStatus(column.status)" :loading="loading" @activity-moved="handleActivityMoved"
          @view-history="handleViewHistory" @view-subtask-history="handleViewSubtaskHistory"
          @view-activity="handleViewActivity" @add-activity="handleAddActivity" @edit-activity="handleEditActivity"
          @delete-activity="handleDeleteActivity" @duplicate-activity="handleDuplicateActivity"
          @add-subtask="handleAddSubtask" @edit-subtask="handleEditSubtask" @delete-subtask="handleDeleteSubtask"
          @update-subtask-status="handleUpdateSubtaskStatus" @update-activity-status="handleUpdateActivityStatus" />
      </v-col>
    </v-row>
  </div>
</template>

<script setup>
import { computed } from 'vue'
import KanbanColumn from './KanbanColumn.vue'

const props = defineProps({
  activities: {
    type: Array,
    default: () => []
  },
  loading: {
    type: Boolean,
    default: false
  }
})

const emit = defineEmits([
  'activityMoved',
  'addActivity',
  'editActivity',
  'viewActivity',
  'viewHistory',
  'deleteActivity',
  'duplicateActivity',
  'addSubtask',
  'editSubtask',
  'viewSubtaskHistory',
  'deleteSubtask',
  'updateSubtaskStatus',
  'updateActivityStatus'
])

const kanbanColumns = [
  {
    title: 'Não Iniciadas',
    status: 'not_started',
    color: 'grey'
  },
  {
    title: 'Em Andamento',
    status: 'in_progress',
    color: 'warning'
  },
  {
    title: 'Concluídas',
    status: 'completed',
    color: 'success'
  }
]

const getActivitiesByStatus = (status) => {
  if (!props.activities || !Array.isArray(props.activities)) {
    return []
  }

  return props.activities.filter(activity => {
    if (!activity) return false
    return activity.status === status
  })
}

const handleActivityMoved = (event) => {
  emit('activityMoved', event)
}

const handleViewHistory = (activityId) => {
  emit('viewHistory', activityId)
}

const handleViewSubtaskHistory = (subtaskId) => {
  emit('viewSubtaskHistory', subtaskId)
}


const handleAddActivity = (status) => {
  emit('addActivity', { status })
}

const handleEditActivity = (activityId) => {
  emit('editActivity', activityId)
}

const handleDeleteActivity = (activityId) => {
  emit('deleteActivity', activityId)
}

const handleDuplicateActivity = (activityId) => {
  emit('duplicateActivity', activityId)
}

const handleAddSubtask = (activityId) => {
  emit('addSubtask', activityId)
}

const handleViewActivity = (activityId) => {
  emit('viewActivity', activityId)
}

const handleEditSubtask = (subtaskId) => {
  emit('editSubtask', subtaskId)
}

const handleDeleteSubtask = (subtaskId) => {
  emit('deleteSubtask', subtaskId)
}

const handleUpdateSubtaskStatus = (data) => {
  emit('updateSubtaskStatus', data)
}

const handleUpdateActivityStatus = (data) => {
  emit('updateActivityStatus', data)
}
</script>

<style scoped>
.kanban-board {
  height: 100%;
  overflow-x: auto;
  padding: 16px 0;
}

.kanban-columns {
  height: 100%;
  min-height: 600px;
}

.kanban-column-wrapper {
  padding: 0 8px;
  height: 100%;
}

.kanban-column-wrapper:first-child {
  padding-left: 0;
}

.kanban-column-wrapper:last-child {
  padding-right: 0;
}

/* Responsividade */
@media (max-width: 960px) {
  .kanban-columns {
    flex-direction: column;
    min-height: auto;
  }

  .kanban-column-wrapper {
    padding: 8px 0;
    height: auto;
    min-height: 300px;
  }

  .kanban-column-wrapper:first-child {
    padding-left: 0;
    padding-top: 0;
  }

  .kanban-column-wrapper:last-child {
    padding-right: 0;
    padding-bottom: 0;
  }
}

@media (max-width: 600px) {
  .kanban-board {
    padding: 8px 0;
  }

  .kanban-column-wrapper {
    padding: 4px 0;
    min-height: 250px;
  }
}

/* Scrollbar personalizada para o board */
.kanban-board::-webkit-scrollbar {
  height: 8px;
}

.kanban-board::-webkit-scrollbar-track {
  background: rgb(var(--v-theme-surface-variant));
  border-radius: 4px;
}

.kanban-board::-webkit-scrollbar-thumb {
  background: rgb(var(--v-theme-outline));
  border-radius: 4px;
}

.kanban-board::-webkit-scrollbar-thumb:hover {
  background: rgb(var(--v-theme-outline-variant));
}
</style>
